import { render, staticRenderFns } from "./new-activity.vue?vue&type=template&id=819a66ac&scoped=true&"
import script from "./new-activity.vue?vue&type=script&lang=ts&"
export * from "./new-activity.vue?vue&type=script&lang=ts&"
import style0 from "./new-activity.vue?vue&type=style&index=0&id=819a66ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819a66ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
